export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    cardWidgetLoaded: function (data) {
      const widgetItems = data.items;

      if (widgetItems.length == 0) {
        $('.tier-3-container .inner-container').addClass(`#${widgetName}-no-data`);
        $(`#${widgetName}`).remove();
        $(`.tier-3-container .left-wraper`).remove();
      } else {
        updateSeoWidget(widgetItems);
      }
    },
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    showDescription: true,
    moreButton: {
      visible: true,
      text: 'learn more',
    },
  });

  // ****************************************************************
  // Function Helpers
  function updateSeoWidget(data) {
    $(`#${widgetName} .card-widget-item`).each(function () {
      const newTitle = data[0].Title;
      let $card = $(this);

      $card.find('.card-widget-title').replaceWith(`<h1 class="main-title"">${newTitle}</h1>`);
      $card.find('.moreButton').addClass('button').removeClass('moreButton').removeAttr('target');
    });
  }
}
